import React from "react";

React.lazy(() =>
    import(
        /* webpackMode: "eager" */
        "@omni/components/components/Account/RequestBonusCard/requestBonusCard.container"
    ).then((module) => ({
        default: module.RequestBonusCard
    }))
);
